import React, { useEffect } from 'react';
import style from '../css/About.module.css';
import NavBar from '../components/navigation/NavBar';
import ContactForm from '../components/common/ContactForm';
import Footer from '../components/common/Footer';
import Map from '../components/common/Map';
import AboutTop from '../components/common/AboutTop';
import InfoList from '../components/common/InfoList';
import BottomNav from '../components/navigation/BottomNav';

function About() {
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);
	return (
		<div>
			<div className="sticky">
				<NavBar />
			</div>
			<AboutTop />
			<div className={style.mar} />
			<div className={style.container_One}>
				<img
					src={require('../components/images/about-page.jpg')}
					alt="Image"
					className={style.image1}
				/>
				<div className={style.container1}>
					<p className={style.txt}>OUR TRUST</p>
					<p className={style.txt2}>
						Our trust firmly believes that every individual deserves access to
						education, regardless of their background. We are dedicated to
						empowering individuals from marginalized and underprivileged
						communities through various initiatives. By offering scholarships,
						mentoring, and career guidance, we aim to provide a pathway for a
						brighter future. Moreover, we conduct workshops and training
						sessions focused on personal development, employability skills, and
						entrepreneurship to equip individuals with essential life skills.
						Beyond education, we also actively support health and sanitation
						initiatives, ensuring that communities have access to clean water,
						healthcare facilities, and hygiene education.
					</p>
				</div>
			</div>
			<Map />
			<Footer />
			<div className="sticky_mob">
				<BottomNav />
			</div>
		</div>
	);
}

export default About;
